import { Box } from "@mui/system";
import React from "react";
import CardTable from "./components/CardTable";

export default function CardList(): JSX.Element {
    return <Box>
        <CardTable />
    </Box>
}